import { ChangeDetectionStrategy, Component, input, signal, TemplateRef, ViewEncapsulation } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";

@Component({
    standalone: true,
    selector: "s25-ng-image-with-placeholder",
    template: `
        @if (!error()) {
            <img [src]="url()" [alt]="altText()" (error)="error.set(true)" />
        } @else {
            <ng-container [ngTemplateOutlet]="placeholder()" />
        }
    `,
    styles: `
        :host {
            display: block;
        }

        img {
            height: 100%;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet],
})
export class S25ImageWithPlaceholderComponent {
    readonly url = input.required<string | undefined>();
    readonly altText = input.required<string>();
    readonly placeholder = input.required<TemplateRef<void>>();

    readonly error = signal(false);
}
